import React from 'react';
import { useGetAllEmailTypes } from '../../../query/mail';
import useDeepCompareEffect from 'react-use/lib/useDeepCompareEffect';
import { useEditEmailTypesStore } from './store';
import EmailTypesTable from './EmailTypesTable';
import { Button, Icon, Spin } from 'antd';
import PermissionGuard from '../../../components/miscellaneous/PermissionGuard';
import EditEmailTypes from './EditEmailTypes';
import { useConfigureEmailTypes } from '../../../mutation/mail';

export default function EmailTypes() {
  const { data } = useGetAllEmailTypes();
  const {
    editMode,
    setEmailTypes,
    toggleEditMode,
    emailTypes,
  } = useEditEmailTypesStore();
  const { isLoading, mutateAsync } = useConfigureEmailTypes();
  useDeepCompareEffect(() => {
    setEmailTypes(data);
  }, [data]);
  return (
    <div>
      <div className="flex items-center space-x-4" style={{ marginBottom: 10 }}>
        <h1 cy-data="home-title">Manage Email Types</h1>
        {editMode && (
          <div className="flex items-center space-x-2">
            <Icon
              style={{ fontSize: 22 }}
              theme="twoTone"
              twoToneColor="#52c41a"
              type="check-circle"
              onClick={() => {
                mutateAsync(emailTypes)
                  .then(() => toggleEditMode())
                  .catch(() => {});
              }}
            />
            <Icon
              style={{ fontSize: 22 }}
              theme="twoTone"
              twoToneColor="#ff3333"
              type="close-circle"
              onClick={() => {
                // set back to prev state
                setEmailTypes(data);
                toggleEditMode();
              }}
            />
          </div>
        )}
        <PermissionGuard requiredPermission="mail.types.modify">
          {!editMode && <Button icon="edit" onClick={() => toggleEditMode()} />}
        </PermissionGuard>
      </div>
      <Spin spinning={isLoading}>
        {editMode ? <EditEmailTypes /> : <EmailTypesTable />}
      </Spin>
    </div>
  );
}
